import { FormComponentProps } from '../../../global-forms/GlobalForms.types';
import styles from '@lmt/unicorn-shared/app/components/global-forms/Content.module.scss';
import React, { useCallback } from 'react';
import { Field } from '../../../common/Field';
import { Input } from '../../../common/ui-kit/inputs/Input';
import { SubmitButton } from '../../../common/ui-kit/buttons/SubmitButton';
import { Error } from '../../../common/Error';
import { nameof } from '@lmt/unicorn-shared/app/helpers/nameof';
import { useForm } from 'react-hook-form';
import { useErrorHandler } from '@lmt/unicorn-shared/app/helpers/form/useErrorHandler';
import {
  emailRule,
  requiredRule,
} from '@lmt/unicorn-shared/app/helpers/form/react-hook-form-helper';
import { QueryFactory } from '@lmt/shared-types';
import { toast } from 'react-toastify';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';

interface Props {
  subtenantId: number;
}

type FormData = {
  email: string;
};

export const SendTestMessageForm: React.FC<FormComponentProps & Props> = (
  props,
) => {
  const { subtenantId, formType, formId, tryCompleteForm } = props;
  const { register, handleSubmit, formState, setError } = useForm<FormData>({
    shouldFocusError: true,
    mode: 'onSubmit',
  });
  const i18next = useScopedTranslation('subtenant_settings.mail_settings.form');

  const submitForm = useErrorHandler(
    useCallback(
      async (data: FormData) => {
        await tryCompleteForm(formType, formId, async () => {
          if (data.email) {
            await QueryFactory.SmtpSettingsClient.sendTestMessage(
              subtenantId!,
              data.email,
            );
            toast(i18next.t('message_was_send'), { type: 'success' });
          }
        });
      },
      [formType, formId, tryCompleteForm],
    ),
    setError,
  );

  return (
    <form
      className={styles.autoSizedContainer}
      onSubmit={handleSubmit(submitForm.handler)}
    >
      <div className={styles.dataContainer}>
        <Field title={i18next.t('email_address')}>
          <Input
            {...register(nameof('email'), {
              ...requiredRule(),
              ...emailRule(),
            })}
            errorText={formState.errors.email?.message}
          />
        </Field>
      </div>
      <div className={styles.submitContainer}>
        <Error error={submitForm.overallServerError} />
        <SubmitButton
          submitting={formState.isSubmitting}
          className={styles.submit}
          title={i18next.t('send_message')}
        />
      </div>
    </form>
  );
};
